import React, {useEffect, useState} from 'react';
import PlainClientSynthesis from './PlainClientSynthesis';
import {loadSynthesisBranding} from './ClientSynthesisBranding';
import {decodeSynthesisLogo} from '../utils/clientSynthesisLogo';
import './PremiumClientSynthesis.css';

export default function PremiumClientSynthesis({content='', testId, sessionId, metadata={}}) {
  const [state, setState] = useState({});
  useEffect(() => {
    let active = true;
    loadSynthesisBranding(sessionId).then(async branding => {
      const logo = await decodeSynthesisLogo(branding);
      if (active) setState({sessionId, branding, logo});
    });
    return () => { active = false; };
  }, [sessionId]);
  // A changed session must never briefly show the previous practice's branding.
  const {branding={}, logo} = state.sessionId === sessionId ? state : {};
  const brand = branding.enabled ? branding : {};
  return <article className="cs-premium" lang="en" aria-label="Client Synthesis">
    {branding.cover !== false && <header className="cs-cover">
      <div className="cs-cover-top">
        <span className="cs-wordmark">INSIGHT</span>
        <h2>Client Synthesis</h2>
        <p className="cs-kicker">Structured Qualitative Exploration</p>
        <svg className="cs-cover-wave" viewBox="0 0 210 34" preserveAspectRatio="none" aria-hidden="true"><path fill="#24696d" d="M0 12C70 -11 140 33 210 6V34H0Z"/><path fill="#fff" d="M0 14C70 -8 140 36 210 8V34H0Z"/></svg>
      </div>
      <div className={`cs-cover-lower${logo ? ' cs-with-logo' : ''}`}>
        {logo && <img className="cs-clinic-logo" src={logo.src} alt="Approved practice logo" onError={() => setState(s => ({...s, logo:null}))}/>}
        <div className="cs-cover-rule"/>
        <p className="cs-personal-title">A Personalised Exploration Report</p>
        <dl>{[['Prepared for',metadata.clientName],['Date',metadata.date],['Prepared by',brand.professional_name || metadata.psychologistName],['Professional designation',brand.designation],['Practice',brand.clinic],['Contact',brand.contact]].filter(([,v]) => v).map(([label,value]) => <div key={label}><dt>{label}:</dt><dd>{value}</dd></div>)}</dl>
        <p className="cs-confidential">Confidential · For authorized professional and client discussion</p>
      </div>
    </header>}
    <div className="cs-document"><PlainClientSynthesis content={content} testId={testId}/></div>
    <footer>INSIGHT · Structured Qualitative Exploration · Confidential</footer>
  </article>;
}
